import React from 'react';
import { Text } from '@components/typography';
import { JoykitColor } from '@components/themes';
import { WrapperSlider, ContentSlider } from './PropsSlider.styles';
import { useTranslation } from 'react-i18next';

interface PropsSliderProps {
  eyebrowColor?: JoykitColor;
  textColor?: JoykitColor;
}

export const PropsSlider: React.FC<PropsSliderProps> = ({ eyebrowColor = 'mono7', textColor = 'mono7' }) => {
  const { t } = useTranslation('babyRegistry');
  const hero = t('hero');

  return (
    <>
      <Text variant="sectionEyeBrow20" color={eyebrowColor} tagName="h1" marginBottom={5}>
        {hero.eyebrow}
      </Text>
      <Text variant="hed72Hero" color={textColor} tagName="span">
        {hero.title}
      </Text>
      <WrapperSlider marginBottom={6}>
        <ContentSlider variant="hed72Hero" color={textColor} tagName="div">
          {hero.slider.map((item) => (
            <>
              {item}
              <br />
            </>
          ))}
        </ContentSlider>
      </WrapperSlider>
    </>
  );
};
